

export const columns = [
    {
        type: 'index',
        width: 65,
        title: '序号'
    },
    {
        title: '流程名称',
        key: 'name',
        minWidth: 160,
        show: true
    },
    {
        title: '流程标识',
        key: 'prefix',
        minWidth: 160,
        show: true
    },
    {
        title: '数据表',
        key: 'assembyName',
        minWidth: 160,
        show: true
    },
    // {
    //     title: '角色类型',
    //     slot: 'type',
    //     minWidth: 100,
    //     show: true
    // },
    {
        title: '状态',
        slot: 'isDeleted',
        minWidth: 100,
        maxWidth: 100,
        show: true
    },
    {
        title: '创建时间',
        slot: 'createdTime',
        minWidth: 180,
        maxWidth: 180,
        show: true
    },
    {
        title: '操作',
        slot: 'action',
        minWidth: 145,
        maxWidth: 145,
        show: true
    },
]

